import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';
import type {
  AddItemRequest,
  GenerateRequest,
  GenerateResponse,
  ReorderRequest,
  ShoppingListDto,
  ShoppingListItemDto,
  ToggleRequest,
} from './shoppingTypes.js';

export function generateShoppingList(
  body: GenerateRequest,
): Promise<GenerateResponse> {
  return apiPost<GenerateResponse>('/api/shopping/generate', body);
}

export function getActiveShoppingList(): Promise<ShoppingListDto | null> {
  return apiGet<ShoppingListDto | null>('/api/shopping/active');
}

export function patchShoppingItem(
  id: number,
  body: ToggleRequest | ReorderRequest,
): Promise<ShoppingListItemDto> {
  return apiPatch<ShoppingListItemDto>(`/api/shopping/items/${id}`, body);
}

export function addShoppingItem(
  body: AddItemRequest,
): Promise<ShoppingListItemDto> {
  return apiPost<ShoppingListItemDto>('/api/shopping/items', body);
}

export function deleteShoppingItem(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/shopping/items/${id}`);
}

export function shoppingPdfUrl(id: number): string {
  return `/api/shopping/${id}/pdf`;
}
